"use client";
import React, { useState, useEffect } from "react";
import posthog from "posthog-js";

interface AIChatButtonProps {
  projectId: string;
  projectName: string;
  className?: string;
}

const AIChatButton: React.FC<AIChatButtonProps> = ({ projectId, projectName, className }) => {
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    posthog.onFeatureFlags(() => {
      setShowButton(posthog.getFeatureFlag("ai-chat") === true);
    });
  }, []);

  if (!showButton) return null;

  return (
    <div className={`flex flex-col items-center w-full max-w-md ${className || ""}`}>
      <button
        className="relative btn btn-info btn-lg px-8 py-3 font-bold text-white shadow-lg overflow-hidden animate-shimmer group min-w-[280px] w-full max-w-md"
        style={{
          background:
            "linear-gradient(90deg, #6366f1 0%, #a21caf 50%, #6366f1 100%)",
        }}
        onClick={() => {
          setAiModalOpen(true);
          posthog.capture("ai_chat_button_clicked", { projectId });
        }}
        aria-label="Open AI Chat"
      >
        <span className="absolute inset-0 bg-gradient-to-r from-white/20 via-white/60 to-white/20 opacity-0 group-hover:opacity-100 transition-opacity animate-shimmer" />
        <span className="relative flex items-center gap-2">
          <svg className="w-6 h-6 animate-spin-slow" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v4m0 8v4m8-8h-4M4 12H8m7.07-7.07l-2.83 2.83m0 8.48l2.83 2.83m-8.48-8.48l2.83-2.83m0 8.48l-2.83 2.83" /></svg>
          AI Chat
        </span>
      </button>
      <div className="text-xs text-info-content mt-1 text-center font-medium opacity-80 w-full">
        Ask our advanced AI anything about <span className="font-semibold">{projectName}</span>
      </div>
      <dialog open={aiModalOpen} className="modal z-50">
        <div className="modal-box bg-white text-center">
          <h2 className="text-2xl font-bold mb-2">AI Chat</h2>
          <p className="mb-4">Coming soon</p>
          <button className="btn btn-primary mt-2" onClick={() => setAiModalOpen(false)}>
            Close
          </button>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button onClick={() => setAiModalOpen(false)}>close</button>
        </form>
      </dialog>
    </div>
  );
};

export default AIChatButton; 